import * as Yup from "yup";
import { REGEX } from "../../../../../utils/constants";
/**
 * @description declaration form schema for client validations
 */
export const userProfileSchema = Yup.object().shape({
    email: Yup.string()
          .email("Invalid email address")
          .required("Email address field  is required"),
    fname: Yup.string().trim()
          .required("This field is required")
          .max(50, "This field should be maximumun 50 characters.")
          .matches(REGEX.NAME,
              'This field only accepts alphabets!'),
    lname: Yup.string().trim()
          .required("This field is required")
          .max(50, "This field should be maximumun 50 characters.")
          .matches(REGEX.NAME,
              'This field only accepts alphabets!'),
    phone: Yup.string()
    .trim()
    .matches(
      /^(\([0-9]{3}\) |[0-9]{3}-)?[0-9]{3}-[0-9]{4}$/,
      "Invalid Phone Number"
    )
    .required("This field is required"),
        
 
});



/**
 * @description params intilaization 
 */

export const userProfileInit = {
    fname: '',
    lname: '',
    email:'',
    phone:'',
    address:''
}